import {
  Container,
  Divider,
  Flex,
  Heading,
  HStack,
  Select,
  Spinner,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FaBuilding } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useData } from "../../Contexts/DataContext";
import IdeaBoard from "../Idea Board/IdeaBoard";
import Overview from "./Overview/Overview";
import Tracker from "./ProjectTracker/Tracker";
import { useResponsive } from "../../Contexts/ResponsiveContext";

function ClientDetail() {
  const [tabIndex, setTabIndex] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const clientTenantId = queryParams.get("ctid");
  const { isMobile } = useResponsive();

  const {
    clients,
    sows,
    selectedClientId,
    setSelectedClientId,
    selectedClient,
    selectedSowId,
    setSelectedSowId,
    selectedSow,
  } = useData();

  // 🧠 Match client from URL and update context
  useEffect(() => {
    if (!clientTenantId || !clients.length) return;

    const matchedClient = clients.find((c) => c.tenantId === clientTenantId);
    if (matchedClient && matchedClient.id !== selectedClientId) {
      setSelectedClientId(matchedClient.id);
    }
  }, [clientTenantId, clients, selectedClientId, setSelectedClientId]);

  if (!selectedClient) {
    return (
      <Flex justify="center" align="center" h="100vh">
        <Spinner size="xl" color="blue.500" />
      </Flex>
    );
  }

  const clientSows = sows.filter((s) => s.clientId === selectedClient.id);

  return (
    <Container maxW={"container.2xl"}>
      <Flex mt={4} alignItems="center" justifyContent="space-between">
        <HStack spacing={2}>
          <FaBuilding color={"black"} />
          <Heading fontWeight="normal" color="black" as="h1" size="lg">
            {selectedClient.name}
          </Heading>
        </HStack>

        <HStack align="center">
          {!isMobile && (
            <Text color="black" fontSize="xs">
              Active Project(s):
            </Text>
          )}
          <Select
            size="sm"
            placeholder={
              clientSows.length === 0 ? "No SOWs available" : "Select SOW"
            }
            w="250px"
            value={selectedSowId || ""}
            onChange={(e) => setSelectedSowId(e.target.value)}
            isDisabled={clientSows.length === 0}
          >
            {clientSows.map((sow) => (
              <option key={sow.id} value={sow.id}>
                {sow.projectName}
              </option>
            ))}
          </Select>
        </HStack>
      </Flex>

      <Divider borderColor="gray.300" my={4} />

      <Tabs
        variant="solid-rounded"
        colorScheme="blue"
        isLazy
        size="sm"
        index={tabIndex}
        onChange={(index) => setTabIndex(index)}
      >
        <TabList
          m={5}
          mr={{ base: 0, md: "1em" }}
          justifyContent={{ base: "center", md: "flex-start" }}
        >
          <Tab color="gray.700" _selected={{ bg: "blue.500", color: "white" }}>
            Overview
          </Tab>
          <Tab color="gray.700" _selected={{ bg: "blue.500", color: "white" }}>
            Project Tracker
          </Tab>
          <Tab color="gray.700" _selected={{ bg: "blue.500", color: "white" }}>
            Idea Board
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <Overview setTabIndex={setTabIndex} />
          </TabPanel>
          <TabPanel>
            <Tracker client={selectedClient} />
          </TabPanel>
          <TabPanel>
            <IdeaBoard client={selectedClient} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
}

export default ClientDetail;
